/* NoCapCare — storefront behaviour.
   Vanilla, no dependencies. Everything hangs off data attributes so
   sections stay editable in the theme editor without touching JS.
   Every init function is idempotent (data-nc-ready) and re-runs on
   shopify:section:load. */
(function () {
	'use strict';

	var NC = (window.NC = window.NC || {});
	NC.routes = NC.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
	var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var root = document.documentElement;

	function $(sel, ctx) { return (ctx || document).querySelector(sel); }
	function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
	function once(el, key) {
		if (el.hasAttribute('data-nc-ready-' + key)) return false;
		el.setAttribute('data-nc-ready-' + key, '');
		return true;
	}

	/* ---------------------------------------------------------- money
	   Indian grouping, mirrors snippets/nc-money.liquid. */
	NC.money = function (cents) {
		var rupees = Math.round((cents || 0) / 100).toString();
		var out = '';
		for (var i = 0; i < rupees.length; i++) {
			var fromRight = rupees.length - i - 1;
			if (fromRight >= 2 && fromRight % 2 === 0 && out !== '') out += ',';
			out += rupees[i];
		}
		return '₹' + out;
	};

	/* ----------------------------------------------------------- events */
	var bus = document.createElement('i');
	NC.on = function (name, fn) { bus.addEventListener(name, fn); };
	NC.emit = function (name, detail) { bus.dispatchEvent(new CustomEvent(name, { detail: detail })); };

	/* ------------------------------------------------------------- cart */
	function json(r) {
		return r.json().then(function (b) {
			if (!r.ok) throw new Error(b.description || b.message || 'Something went sideways. Try again?');
			return b;
		});
	}

	NC.cart = {
		state: null,
		get: function () {
			return fetch(NC.routes.cart + '.js', { headers: { Accept: 'application/json' } })
				.then(json)
				.then(function (cart) {
					NC.cart.state = cart;
					NC.emit('cart:updated', cart);
					return cart;
				});
		},
		add: function (items) {
			return fetch(NC.routes.cartAdd + '.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({ items: items })
			})
				.then(json)
				.then(function (added) {
					return NC.cart.get().then(function (cart) {
						NC.emit('cart:changed', cart);
						return added;
					});
				});
		},
		change: function (key, quantity) {
			return fetch(NC.routes.cartChange + '.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({ id: key, quantity: quantity })
			})
				.then(json)
				.then(function (cart) {
					NC.cart.state = cart;
					NC.emit('cart:updated', cart);
					NC.emit('cart:changed', cart);
					return cart;
				});
		},
		note: function (note) {
			return fetch((NC.routes.cartUpdate || '/cart/update') + '.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({ note: note })
			}).then(json);
		}
	};

	/* Live count in the header, with a little bump when it changes. */
	var lastCount = null;
	NC.on('cart:updated', function (e) {
		var count = e.detail ? e.detail.item_count : 0;
		$$('[data-nc-cart-count]').forEach(function (el) {
			el.textContent = count;
			var link = el.closest('[data-nc-cart-link]');
			if (link) link.setAttribute('aria-label', 'Bag, ' + count + (count === 1 ? ' item' : ' items'));
			if (lastCount !== null && count > lastCount && !reduceMotion) {
				el.classList.remove('is-bump');
				void el.offsetWidth;
				el.classList.add('is-bump');
			}
		});
		lastCount = count;
	});

	/* -------------------------------------------------------- overlays
	   One open/close for the cart drawer, quick add, notify modal, mobile
	   nav, search and the lightbox. Focus is trapped while open. */
	var stack = [];

	NC.overlay = {
		open: function (el, focusSel) {
			if (!el) return;
			stack.push({ el: el, back: document.activeElement });
			el.hidden = false;
			void el.offsetWidth;
			el.classList.add('is-open');
			root.classList.add('nc-no-scroll');
			var f = (focusSel && $(focusSel, el)) || $('[data-nc-close]', el);
			if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 30);
			NC.emit('overlay:open', el);
		},
		close: function (el) {
			var idx = -1;
			for (var i = stack.length - 1; i >= 0; i--) if (!el || stack[i].el === el) { idx = i; break; }
			if (idx < 0) return;
			var item = stack.splice(idx, 1)[0];
			item.el.classList.remove('is-open');
			setTimeout(function () { if (!item.el.classList.contains('is-open')) item.el.hidden = true; }, 320);
			if (!stack.length) root.classList.remove('nc-no-scroll');
			if (item.back && item.back.focus) item.back.focus({ preventScroll: true });
			NC.emit('overlay:close', item.el);
		},
		top: function () { return stack.length ? stack[stack.length - 1].el : null; }
	};

	document.addEventListener('click', function (e) {
		var closer = e.target.closest('[data-nc-close]');
		var top = NC.overlay.top();
		if (closer && top && top.contains(closer)) { e.preventDefault(); NC.overlay.close(top); return; }
		if (top && e.target === top) NC.overlay.close(top);
	});

	document.addEventListener('keydown', function (e) {
		var top = NC.overlay.top();
		if (!top) return;
		if (e.key === 'Escape') { NC.overlay.close(top); return; }
		if (e.key !== 'Tab') return;
		var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', top)
			.filter(function (x) { return x.offsetParent !== null; });
		if (!f.length) return;
		if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
		else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
	});

	/* ----------------------------------------------------- cart drawer */
	var Drawer = {
		el: function () { return $('[data-nc-drawer]'); },
		open: function () {
			var el = Drawer.el();
			if (!el) { window.location.href = NC.routes.cart; return; }
			NC.overlay.open(el);
		},
		refresh: function () {
			var el = Drawer.el();
			if (!el) return Promise.resolve();
			return fetch(window.location.pathname + '?sections=nc-cart-drawer')
				.then(function (r) { return r.json(); })
				.then(function (data) {
					var html = data['nc-cart-drawer'];
					if (!html) return;
					var doc = new DOMParser().parseFromString(html, 'text/html');
					['[data-nc-drawer-body]', '[data-nc-drawer-foot]', '[data-nc-drawer-count]'].forEach(function (sel) {
						var fresh = $(sel, doc);
						var current = $(sel, el);
						if (!fresh || !current) return;
						current.innerHTML = fresh.innerHTML;
						current.hidden = fresh.hasAttribute('hidden');
					});
					initAll(el);
				})
				.catch(function () {});
		}
	};
	NC.drawer = Drawer;
	NC.on('cart:changed', function () { Drawer.refresh(); refreshCartPage(); });

	/* /cart page re-renders the same way. */
	function refreshCartPage() {
		var page = $('[data-nc-cart-page]');
		if (!page) return;
		var id = page.getAttribute('data-section');
		fetch(window.location.pathname + '?sections=' + id)
			.then(function (r) { return r.json(); })
			.then(function (data) {
				var doc = new DOMParser().parseFromString(data[id], 'text/html');
				var fresh = $('[data-nc-cart-page]', doc);
				if (fresh) { page.innerHTML = fresh.innerHTML; initAll(page); }
			});
	}

	document.addEventListener('click', function (e) {
		var open = e.target.closest('[data-nc-drawer-open]');
		if (open) { e.preventDefault(); Drawer.open(); return; }

		var minus = e.target.closest('[data-nc-line-minus]');
		var plus = e.target.closest('[data-nc-line-plus]');
		var remove = e.target.closest('[data-nc-line-remove]');
		var control = minus || plus || remove;
		if (control) {
			e.preventDefault();
			var key = control.getAttribute('data-key');
			var qty = parseInt(control.getAttribute('data-qty') || '0', 10);
			var next = remove ? 0 : minus ? qty - 1 : qty + 1;
			var row = control.closest('[data-nc-line]');
			if (row) row.classList.add('is-busy');
			NC.cart.change(key, Math.max(0, next)).catch(function (err) {
				if (row) row.classList.remove('is-busy');
				NC.toast({ title: 'Hmm.', text: err.message });
			});
		}
	});

	document.addEventListener('change', function (e) {
		var note = e.target.closest('[data-nc-cart-note]');
		if (note) NC.cart.note(note.value);
	});

	/* ------------------------------------------------------------ toast */
	var toastTimer;
	NC.toast = function (opts) {
		var el = $('[data-nc-toast-el]');
		if (!el) {
			el = document.createElement('div');
			el.className = 'nc-toast';
			el.setAttribute('data-nc-toast-el', '');
			el.setAttribute('role', 'status');
			el.setAttribute('aria-live', 'polite');
			document.body.appendChild(el);
		}
		el.innerHTML =
			(opts.image ? '<img class="nc-toast__img" src="' + opts.image + '" alt="" width="36" height="36">' : '') +
			'<span class="nc-toast__text"><strong></strong><span></span></span>' +
			(opts.cta === false ? '' : '<button type="button" class="nc-btn nc-btn--light" data-nc-drawer-open>View bag</button>');
		$('strong', el).textContent = opts.title || '';
		$('.nc-toast__text span', el).textContent = opts.text || '';
		el.classList.remove('is-in');
		void el.offsetWidth;
		el.classList.add('is-in');
		clearTimeout(toastTimer);
		toastTimer = setTimeout(function () { el.classList.remove('is-in'); }, 4200);
	};

	/* --------------------------------------------------------- add forms
	   [data-nc-add-form] — one variant (name="id") or many
	   ([data-nc-item] inputs; checkboxes only count when checked).
	   data-nc-toast   → toast instead of opening the drawer
	   data-nc-stay    → neither (used inside the drawer upsell) */
	function buttonState(btn, state) {
		if (!btn) return;
		var label = $('[data-nc-label]', btn) || btn;
		if (!btn.hasAttribute('data-orig')) btn.setAttribute('data-orig', label.textContent.trim());
		btn.classList.remove('is-loading', 'is-done');
		if (state === 'loading') { btn.classList.add('is-loading'); btn.disabled = true; }
		else if (state === 'done') {
			btn.classList.add('is-done');
			label.textContent = btn.getAttribute('data-done') || 'Added. Good call.';
			btn.disabled = false;
			setTimeout(function () {
				btn.classList.remove('is-done');
				label.textContent = btn.getAttribute('data-orig');
			}, 2200);
		} else { btn.disabled = false; label.textContent = btn.getAttribute('data-orig'); }
	}

	document.addEventListener('submit', function (e) {
		var form = e.target.closest('[data-nc-add-form]');
		if (!form) return;
		e.preventDefault();

		var items = [];
		var qtyField = $('[name="quantity"]', form);
		var qty = Math.max(1, parseInt(qtyField ? qtyField.value : 1, 10) || 1);
		var idField = form.querySelector('[name="id"]');
		if (idField && idField.value) items.push({ id: Number(idField.value), quantity: qty });
		$$('[data-nc-item]', form).forEach(function (input) {
			if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
			if (input.disabled || !input.value) return;
			items.push({ id: Number(input.value), quantity: 1 });
		});
		if (!items.length) return;

		var btn = e.submitter || $('[type="submit"]', form);
		var errorEl = $('[data-nc-add-error]', form);
		if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; }
		buttonState(btn, 'loading');

		NC.cart
			.add(items)
			.then(function (added) {
				buttonState(btn, 'done');
				if (form.hasAttribute('data-nc-stay')) return;
				var first = added && added.items && added.items[0];
				if (form.hasAttribute('data-nc-toast')) {
					NC.toast({
						title: 'Added. Good call.',
						text: items.length > 1 ? items.length + ' items in your bag' : first ? first.product_title : '',
						image: first && first.image ? first.image.replace(/(\.[a-z]+)(\?|$)/i, '$1?width=96&') : ''
					});
				} else {
					if (NC.overlay.top() && NC.overlay.top() !== Drawer.el()) NC.overlay.close();
					Drawer.open();
				}
			})
			.catch(function (err) {
				buttonState(btn, 'reset');
				if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
				else NC.toast({ title: 'Hmm, that didn’t work.', text: err.message, cta: false });
			});
	});

	/* ----------------------------------------------------- quick add
	   Multi-variant products open a mini PDP in a drawer. */
	document.addEventListener('click', function (e) {
		var btn = e.target.closest('[data-nc-quick]');
		if (!btn) return;
		e.preventDefault();
		var shell = $('[data-nc-quick-shell]');
		if (!shell) { window.location.href = btn.getAttribute('data-nc-quick'); return; }
		var body = $('[data-nc-quick-body]', shell);
		body.innerHTML = '<p class="nc-quick__loading">Loading…</p>';
		NC.overlay.open(shell);
		fetch(btn.getAttribute('data-nc-quick') + (btn.getAttribute('data-nc-quick').indexOf('?') > -1 ? '&' : '?') + 'section_id=nc-quick-add')
			.then(function (r) { return r.text(); })
			.then(function (html) {
				var doc = new DOMParser().parseFromString(html, 'text/html');
				var inner = $('[data-nc-quick-content]', doc);
				body.innerHTML = inner ? inner.innerHTML : '';
				initAll(body);
			});
	});

	/* ------------------------------------------------------ notify me
	   Uses Shopify's own contact form so requests land in the store inbox,
	   tagged with the product. Falls back to a normal submit if Shopify
	   asks for a challenge. */
	document.addEventListener('click', function (e) {
		var open = e.target.closest('[data-nc-notify-open]');
		if (!open) return;
		e.preventDefault();
		var modal = $('[data-nc-notify-modal]');
		if (!modal) return;
		var name = open.getAttribute('data-nc-notify-open');
		$$('[data-nc-notify-product]', modal).forEach(function (f) { f.value = name; });
		$$('[data-nc-notify-name]', modal).forEach(function (f) { f.textContent = name; });
		var msg = $('[data-nc-notify-msg]', modal);
		if (msg) { msg.textContent = ''; msg.className = 'nc-form-msg'; }
		NC.overlay.open(modal, 'input[type="email"]');
	});

	document.addEventListener('submit', function (e) {
		var form = e.target.closest('[data-nc-notify-form]');
		if (!form || form.hasAttribute('data-native')) return;
		e.preventDefault();
		var msg = $('[data-nc-notify-msg]', form) || $('[data-nc-notify-msg]', form.parentNode);
		var btn = $('[type="submit"]', form);
		buttonState(btn, 'loading');
		fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
			.then(function (r) {
				if (r.url && r.url.indexOf('challenge') > -1) { form.setAttribute('data-native', ''); form.submit(); return; }
				buttonState(btn, 'reset');
				if (msg) { msg.textContent = 'Locked in. You’ll hear from us the day it’s back.'; msg.className = 'nc-form-msg is-ok'; }
				form.reset();
			})
			.catch(function () {
				form.setAttribute('data-native', '');
				form.submit();
			});
	});

	/* ------------------------------------------------------- reveal */
	var revealIO =
		'IntersectionObserver' in window && !reduceMotion
			? new IntersectionObserver(
				function (entries) {
					entries.forEach(function (en) {
						if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); }
					});
				},
				{ rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
			)
			: null;

	/* Fail-safe: a plain scroll check runs alongside the observer, so
	   nothing can stay invisible if IntersectionObserver is throttled or
	   unsupported. Stops listening once everything is shown. */
	var pending = [];
	var lastCheck = 0;
	function revealCheck(force) {
		var now = Date.now();
		if (!force && now - lastCheck < 120) return;
		lastCheck = now;
		var limit = window.innerHeight * 0.96;
		pending = pending.filter(function (el) {
			if (el.classList.contains('is-in')) return false;
			if (el.getBoundingClientRect().top < limit) { el.classList.add('is-in'); return false; }
			return true;
		});
	}
	window.addEventListener('scroll', function () { if (pending.length) revealCheck(); }, { passive: true });

	function reveal(ctx) {
		$$('.nc-reveal:not(.is-in)', ctx).forEach(function (el) {
			if (revealIO) { revealIO.observe(el); pending.push(el); } else el.classList.add('is-in');
		});
		setTimeout(function () { revealCheck(true); }, 400);
	}

	/* ------------------------------------------------------- sliders
	   Native scroll-snap. Adds mouse drag, arrows and a progress bar. */
	function sliders(ctx) {
		$$('[data-nc-slider]', ctx).forEach(function (s) {
			if (!once(s, 'slider')) return;
			var track = $('[data-nc-track]', s);
			if (!track) return;
			/* Arrows can live in the section heading, outside the slider. */
			var host = s.closest('.shopify-section') || s;
			var prev = $('[data-nc-prev]', s) || $('[data-nc-prev]', host);
			var next = $('[data-nc-next]', s) || $('[data-nc-next]', host);
			var bar = $('[data-nc-progress] span', s);

			function step() {
				var first = track.children[0];
				var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
				return first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
			}

			function update() {
				var max = track.scrollWidth - track.clientWidth;
				if (prev) prev.disabled = track.scrollLeft <= 4;
				if (next) next.disabled = track.scrollLeft >= max - 4;
				if (bar) {
					var visible = Math.min(1, track.clientWidth / track.scrollWidth);
					bar.style.width = visible * 100 + '%';
					bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * (1 / visible - 1) * 100 : 0) + '%)';
				}
				s.classList.toggle('is-static', max <= 4);
			}

			if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
			if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
			track.addEventListener('scroll', update, { passive: true });
			window.addEventListener('resize', update, { passive: true });
			update();

			/* Mouse drag (touch scrolls natively). */
			var down = false, startX = 0, startLeft = 0, moved = 0;
			track.addEventListener('pointerdown', function (e) {
				if (e.pointerType !== 'mouse' || e.button !== 0) return;
				down = true; moved = 0; startX = e.clientX; startLeft = track.scrollLeft;
			});
			window.addEventListener('pointermove', function (e) {
				if (!down) return;
				var dx = e.clientX - startX;
				moved = Math.max(moved, Math.abs(dx));
				if (moved > 5) track.classList.add('is-dragging');
				track.scrollLeft = startLeft - dx;
			});
			window.addEventListener('pointerup', function () {
				if (!down) return;
				down = false;
				if (track.classList.contains('is-dragging')) {
					var w = step();
					var target = Math.round(track.scrollLeft / w) * w;
					track.classList.remove('is-dragging');
					track.scrollTo({ left: target, behavior: 'smooth' });
				}
			});
			track.addEventListener('click', function (e) { if (moved > 5) { e.preventDefault(); e.stopPropagation(); } }, true);
		});
	}

	/* ------------------------------------------------------------ tabs */
	function tabs(ctx) {
		$$('[data-nc-tabs]', ctx).forEach(function (t) {
			if (!once(t, 'tabs')) return;
			var btns = $$('[role="tab"]', t);
			function select(btn, focus) {
				btns.forEach(function (b) {
					var on = b === btn;
					b.setAttribute('aria-selected', on ? 'true' : 'false');
					b.tabIndex = on ? 0 : -1;
					var panel = document.getElementById(b.getAttribute('aria-controls'));
					if (panel) {
						panel.hidden = !on;
						if (on) reveal(panel);
					}
				});
				if (focus) btn.focus();
			}
			btns.forEach(function (b, i) {
				b.addEventListener('click', function () { select(b); });
				b.addEventListener('keydown', function (e) {
					if (e.key === 'ArrowRight') select(btns[(i + 1) % btns.length], true);
					if (e.key === 'ArrowLeft') select(btns[(i - 1 + btns.length) % btns.length], true);
				});
			});
		});
	}

	/* ------------------------------------------------------ accordions
	   Animates <details>. data-nc-single on the wrapper = one open at a time. */
	function accordions(ctx) {
		$$('details.nc-acc__item', ctx).forEach(function (d) {
			if (!once(d, 'acc')) return;
			var summary = $('summary', d);
			var body = $('.nc-acc__body', d);
			if (!summary || !body) return;
			summary.addEventListener('click', function (e) {
				if (reduceMotion) return;
				e.preventDefault();
				if (d.open) {
					var h = body.scrollHeight;
					body.style.height = h + 'px';
					requestAnimationFrame(function () {
						body.style.transition = 'height 280ms cubic-bezier(.4,0,.2,1)';
						body.style.height = '0px';
					});
					setTimeout(function () { d.open = false; body.style.height = ''; body.style.transition = ''; }, 290);
				} else {
					var group = d.closest('[data-nc-single]');
					if (group) $$('details.nc-acc__item[open]', group).forEach(function (o) { if (o !== d) $('summary', o).click(); });
					d.open = true;
					var full = body.scrollHeight;
					body.style.height = '0px';
					requestAnimationFrame(function () {
						body.style.transition = 'height 320ms cubic-bezier(.16,1,.3,1)';
						body.style.height = full + 'px';
					});
					setTimeout(function () { body.style.height = ''; body.style.transition = ''; }, 330);
				}
			});
		});
	}

	/* ------------------------------------------------------------ flip */
	document.addEventListener('click', function (e) {
		var f = e.target.closest('[data-nc-flip]');
		if (!f || e.target.closest('a')) return;
		f.classList.toggle('is-flipped');
		f.setAttribute('aria-pressed', f.classList.contains('is-flipped') ? 'true' : 'false');
	});
	document.addEventListener('keydown', function (e) {
		var f = e.target.closest && e.target.closest('[data-nc-flip]');
		if (f && (e.key === 'Enter' || e.key === ' ') && e.target === f) { e.preventDefault(); f.click(); }
	});

	/* ---------------------------------------------------- expand toggles
	   [data-nc-toggle] flips aria-expanded and .is-open on its target. */
	document.addEventListener('click', function (e) {
		var t = e.target.closest('[data-nc-toggle]');
		if (!t) return;
		var target = document.getElementById(t.getAttribute('data-nc-toggle')) || t.closest('[data-nc-toggle-host]');
		if (!target) return;
		var open = !target.classList.contains('is-open');
		target.classList.toggle('is-open', open);
		t.setAttribute('aria-expanded', open ? 'true' : 'false');
		var label = t.getAttribute(open ? 'data-label-open' : 'data-label-closed');
		if (label) { var l = $('[data-nc-label]', t) || t; l.textContent = label; }
	});

	/* --------------------------------------------------------- parallax */
	var parallaxEls = [];
	var ticking = false;
	function parallaxFrame() {
		ticking = false;
		var vh = window.innerHeight;
		parallaxEls.forEach(function (el) {
			var r = el.getBoundingClientRect();
			if (r.bottom < 0 || r.top > vh) return;
			var p = (r.top + r.height / 2 - vh / 2) / vh; // -1 .. 1
			el.style.setProperty('--nc-py', (p * -40).toFixed(1) + 'px');
		});
	}
	function parallax(ctx) {
		if (reduceMotion) return;
		$$('.nc-parallax', ctx).forEach(function (el) { if (once(el, 'px')) parallaxEls.push(el); });
		parallaxFrame();
	}
	window.addEventListener('scroll', function () {
		if (!ticking && parallaxEls.length) { ticking = true; requestAnimationFrame(parallaxFrame); }
	}, { passive: true });

	/* ---------------------------------------------------- qty steppers */
	document.addEventListener('click', function (e) {
		var b = e.target.closest('[data-nc-step]');
		if (!b) return;
		var wrap = b.closest('.nc-qty');
		var input = wrap && $('input', wrap);
		if (!input) return;
		var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-nc-step'), 10);
		input.value = Math.max(1, Math.min(v, parseInt(input.max || 99, 10)));
		input.dispatchEvent(new Event('change', { bubbles: true }));
	});

	/* ------------------------------------------------ sticky add to cart */
	function stickyAtc() {
		var bar = $('[data-nc-sticky-atc]');
		var anchor = $('[data-nc-atc-anchor]');
		if (!bar || !anchor || !('IntersectionObserver' in window) || !once(bar, 'sticky')) return;
		var footer = $('.nc-footer');
		var pastAnchor = false, atFooter = false;
		function apply() {
			var show = pastAnchor && !atFooter;
			bar.classList.toggle('is-visible', show);
			bar.setAttribute('aria-hidden', show ? 'false' : 'true');
			root.classList.toggle('has-sticky-atc', show);
		}
		new IntersectionObserver(function (en) {
			pastAnchor = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
			apply();
		}).observe(anchor);
		if (footer) new IntersectionObserver(function (en) { atFooter = en[0].isIntersecting; apply(); }).observe(footer);
	}

	/* ------------------------------------------------------ PDP gallery
	   One big image, arrows, swipe (scroll-snap), thumbs below, dots on
	   mobile, hover zoom on desktop, click for a lightbox. */
	function gallery(ctx) {
		$$('[data-nc-gallery]', ctx).forEach(function (g) {
			if (!once(g, 'gallery')) return;
			var track = $('[data-nc-gallery-track]', g);
			var slides = $$('[data-nc-slide]', g);
			var thumbs = $$('[data-nc-thumb]', g);
			var dots = $$('[data-nc-dot]', g);
			var counter = $('[data-nc-gallery-count]', g);
			if (!track || !slides.length) return;
			var current = 0;

			function setActive(i) {
				current = i;
				thumbs.forEach(function (t, ti) {
					t.classList.toggle('is-active', ti === i);
					t.setAttribute('aria-current', ti === i ? 'true' : 'false');
				});
				dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
				if (counter) counter.textContent = i + 1 + ' / ' + slides.length;
				var t = thumbs[i];
				if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
					t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
				}
				$$('video', g).forEach(function (v, vi) { if (!slides[i].contains(v)) v.pause(); });
			}

			function go(i) {
				i = (i + slides.length) % slides.length;
				track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
				setActive(i);
			}
			g.ncGo = go;

			var st;
			track.addEventListener('scroll', function () {
				clearTimeout(st);
				st = setTimeout(function () {
					var i = Math.round(track.scrollLeft / track.clientWidth);
					if (i !== current && slides[i]) setActive(i);
				}, 60);
			}, { passive: true });

			var prev = $('[data-nc-gprev]', g), next = $('[data-nc-gnext]', g);
			if (prev) prev.addEventListener('click', function () { go(current - 1); });
			if (next) next.addEventListener('click', function () { go(current + 1); });
			thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
			dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
			g.addEventListener('keydown', function (e) {
				if (e.key === 'ArrowRight') go(current + 1);
				if (e.key === 'ArrowLeft') go(current - 1);
			});

			/* Hover zoom — desktop, fine pointers only. */
			if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
				slides.forEach(function (s) {
					var img = $('img[data-nc-zoomable]', s);
					if (!img) return;
					s.addEventListener('mousemove', function (e) {
						var r = s.getBoundingClientRect();
						img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
						img.style.transform = 'scale(1.8)';
					});
					s.addEventListener('mouseleave', function () { img.style.transform = ''; });
				});
			}

			/* Lightbox */
			var lb = $('[data-nc-lightbox]');
			slides.forEach(function (s, i) {
				var trigger = $('[data-nc-zoom]', s);
				if (!trigger || !lb) return;
				trigger.addEventListener('click', function () { openLightbox(lb, slides, i); });
			});

			/* Variant with its own image → jump there. */
			NC.on('variant:changed', function (e) {
				var v = e.detail;
				if (!v || !v.featured_media) return;
				slides.forEach(function (s, i) { if (s.getAttribute('data-media-id') == v.featured_media.id) go(i); });
			});
			setActive(0);
		});
	}

	function openLightbox(lb, slides, start) {
		var img = $('[data-nc-lb-img]', lb);
		var count = $('[data-nc-lb-count]', lb);
		var srcs = slides.map(function (s) { return s.getAttribute('data-full'); }).filter(Boolean);
		var i = start;
		function show() {
			img.src = srcs[i];
			if (count) count.textContent = i + 1 + ' / ' + srcs.length;
		}
		lb.ncPrev = function () { i = (i - 1 + srcs.length) % srcs.length; show(); };
		lb.ncNext = function () { i = (i + 1) % srcs.length; show(); };
		show();
		NC.overlay.open(lb);
	}
	document.addEventListener('click', function (e) {
		var lb = e.target.closest('[data-nc-lightbox]');
		if (!lb) return;
		if (e.target.closest('[data-nc-lb-prev]')) lb.ncPrev();
		if (e.target.closest('[data-nc-lb-next]')) lb.ncNext();
	});
	document.addEventListener('keydown', function (e) {
		var lb = NC.overlay.top();
		if (!lb || !lb.hasAttribute('data-nc-lightbox')) return;
		if (e.key === 'ArrowRight') lb.ncNext();
		if (e.key === 'ArrowLeft') lb.ncPrev();
	});
	(function lbSwipe() {
		var sx = null;
		document.addEventListener('touchstart', function (e) {
			if (e.target.closest('[data-nc-lightbox]')) sx = e.touches[0].clientX;
		}, { passive: true });
		document.addEventListener('touchend', function (e) {
			var lb = e.target.closest('[data-nc-lightbox]');
			if (!lb || sx === null) return;
			var dx = e.changedTouches[0].clientX - sx;
			if (Math.abs(dx) > 40) (dx < 0 ? lb.ncNext : lb.ncPrev)();
			sx = null;
		});
	})();

	/* ------------------------------------------------- variant pills (PDP) */
	function variants(ctx) {
		$$('[data-nc-variants]', ctx).forEach(function (r) {
			if (!once(r, 'variants')) return;
			var data = $('[data-nc-variant-data]', r);
			if (!data) return;
			var list;
			try { list = JSON.parse(data.textContent); } catch (err) { return; }
			r.addEventListener('change', function () {
				var chosen = $$('input[type="radio"]:checked', r).map(function (i) { return i.value; });
				var match = list.filter(function (v) {
					return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
				})[0];
				if (!match) return;
				if (r.hasAttribute('data-nc-update-url')) {
					var url = new URL(window.location.href);
					url.searchParams.set('variant', match.id);
					window.history.replaceState({}, '', url);
				}
				var scope = r.closest('[data-nc-product]') || document;
				$$('[data-nc-product-form] [name="id"]', scope).forEach(function (f) { f.value = match.id; });
				NC.emit('variant:changed', match);
				updateVariantUI(scope, match);
			});
		});
	}

	function updateVariantUI(scope, v) {
		var onSale = v.compare_at_price && v.compare_at_price > v.price;
		$$('[data-nc-v-price]', scope).forEach(function (el) { el.textContent = NC.money(v.price); });
		$$('[data-nc-v-compare]', scope).forEach(function (el) { el.textContent = onSale ? NC.money(v.compare_at_price) : ''; el.hidden = !onSale; });
		$$('[data-nc-v-save]', scope).forEach(function (el) {
			el.hidden = !onSale;
			if (onSale) el.textContent = 'You save ' + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '%';
		});
		$$('[data-nc-buy-wrap]', scope).forEach(function (el) { el.classList.toggle('is-sold-out', !v.available); });
		$$('[data-nc-atc]', scope).forEach(function (b) { b.disabled = !v.available; });
		$$('[data-nc-current-variant]', scope).forEach(function (f) { f.value = v.id; });
		$$('[data-nc-notify-product]', scope).forEach(function (f) { f.value = f.getAttribute('data-base') + ' — ' + v.title; });
	}

	/* -------------------------------------------------- pincode checker
	   Honest: validates the pincode and shows a date window built from the
	   store's real policy (dispatch within N days, then courier transit).
	   It does not pretend to query a courier API. */
	function addBusinessDays(d, n) {
		var out = new Date(d);
		while (n > 0) { out.setDate(out.getDate() + 1); if (out.getDay() !== 0) n--; }
		return out;
	}
	function fmt(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }

	function pincode(ctx) {
		$$('[data-nc-pincode]', ctx).forEach(function (f) {
			if (!once(f, 'pin')) return;
			var input = $('input', f);
			var out = $('[data-nc-pincode-result]', f);
			if (!input || !out) return;
			var dispatchMin = parseInt(f.getAttribute('data-dispatch-min') || '1', 10);
			var dispatchMax = parseInt(f.getAttribute('data-dispatch-max') || '7', 10);
			var tMin = parseInt(f.getAttribute('data-transit-min') || '5', 10);
			var tMax = parseInt(f.getAttribute('data-transit-max') || '7', 10);

			function check() {
				var v = (input.value || '').replace(/\D/g, '');
				if (!/^[1-9]\d{5}$/.test(v)) {
					out.innerHTML = 'That doesn’t look like a pincode. 6 digits, no cap.';
					out.className = 'nc-pin__result is-error';
					return;
				}
				var now = new Date();
				var from = addBusinessDays(now, dispatchMin + tMin);
				var to = addBusinessDays(now, dispatchMax + tMax);
				out.innerHTML = '<strong>Delivers to ' + v + '</strong> between ' + fmt(from) + ' and ' + fmt(to) + '. COD available in most pincodes.';
				out.className = 'nc-pin__result is-ok';
				try { localStorage.setItem('nc_pin', v); } catch (err) {}
			}
			f.addEventListener('submit', function (e) { e.preventDefault(); check(); });
			try {
				var saved = localStorage.getItem('nc_pin');
				if (saved) { input.value = saved; check(); }
			} catch (err) {}
		});
	}

	/* ------------------------------------------- bundle / routine builder
	   [data-nc-bundle]: radios or checkboxes carrying data-price. Shows the
	   running total and enables the add button only when something real is
	   picked. Sold-out options are disabled in Liquid. */
	function bundles(ctx) {
		$$('[data-nc-bundle]', ctx).forEach(function (b) {
			if (!once(b, 'bundle')) return;
			var total = $('[data-nc-bundle-total]', b);
			var count = $('[data-nc-bundle-count]', b);
			var btn = $('[data-nc-bundle-btn]', b);
			var ship = $('[data-nc-bundle-ship]', b);
			var threshold = (NC.shipping && NC.shipping.threshold) || 99900;
			function update() {
				var picked = $$('[data-nc-item]', b).filter(function (i) { return i.checked && !i.disabled; });
				var sum = picked.reduce(function (s, i) { return s + parseInt(i.getAttribute('data-price') || '0', 10); }, 0);
				var base = parseInt(b.getAttribute('data-base-price') || '0', 10);
				sum += base;
				if (total) total.textContent = NC.money(sum);
				if (count) count.textContent = picked.length + (base ? 1 : 0);
				if (btn) {
					btn.disabled = picked.length === 0;
					var lbl = $('[data-nc-label]', btn);
					if (lbl && btn.hasAttribute('data-label-one')) {
						lbl.textContent = picked.length > 1 ? btn.getAttribute('data-label-many') : btn.getAttribute('data-label-one');
						btn.removeAttribute('data-orig');
					}
				}
				if (ship) {
					ship.textContent = sum >= threshold ? 'Free shipping unlocked.' : NC.money(threshold - sum) + ' away from free shipping.';
				}
				$$('[data-nc-pick]', b).forEach(function (card) {
					var input = $('input', card);
					card.classList.toggle('is-picked', !!(input && input.checked));
				});
			}
			b.addEventListener('change', update);
			update();
		});
	}

	/* ------------------------------------------------ collection filters
	   Concern chips filter the grid instantly on tags; the URL hash keeps
	   the choice so links like /collections/hair-wash#thinning land
	   pre-filtered. Sort is server-side (?sort_by=). */
	function filters(ctx) {
		$$('[data-nc-filter]', ctx).forEach(function (f) {
			if (!once(f, 'filter')) return;
			var grid = document.getElementById(f.getAttribute('data-nc-filter'));
			if (!grid) return;
			var chips = $$('[data-nc-chip]', f);
			var countEl = $('[data-nc-count]', f);
			var empty = $('[data-nc-empty]', grid.parentNode);

			function apply(tag, push) {
				var shown = 0;
				$$('[data-nc-card]', grid).forEach(function (card) {
					var tags = (card.getAttribute('data-tags') || '').split('|');
					var ok = !tag || tags.indexOf(tag) > -1;
					card.hidden = !ok;
					if (ok) { shown++; card.classList.add('is-in'); }
				});
				grid.classList.toggle('is-filtered', !!tag);
				$$('[data-nc-promo]', grid).forEach(function (p) { p.hidden = shown < 2; });
				chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-nc-chip') === tag ? 'true' : 'false'); });
				if (countEl) countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
				if (empty) empty.hidden = shown > 0;
				if (push && !f.hasAttribute('data-nc-nohash')) history.replaceState({}, '', tag ? '#' + encodeURIComponent(tag.replace(/\s+/g, '-')) : window.location.pathname + window.location.search);
			}

			chips.forEach(function (c) {
				c.addEventListener('click', function () {
					var t = c.getAttribute('data-nc-chip');
					var active = c.getAttribute('aria-pressed') === 'true';
					apply(active || t === '' ? '' : t, true);
				});
			});

			var hash = decodeURIComponent((window.location.hash || '').slice(1)).replace(/-/g, ' ').toLowerCase();
			if (hash) {
				var match = chips.filter(function (c) { return c.getAttribute('data-nc-chip') === hash; })[0];
				if (match) apply(hash, false);
			}
		});

		$$('[data-nc-sort]', ctx).forEach(function (sel) {
			if (!once(sel, 'sort')) return;
			sel.addEventListener('change', function () {
				var url = new URL(window.location.href);
				url.searchParams.set('sort_by', sel.value);
				url.searchParams.delete('page');
				window.location.href = url.toString();
			});
		});
	}

	/* ---------------------------------------------------- header + nav */
	function header() {
		var el = $('[data-nc-header]');
		if (!el || !once(el, 'header')) return;
		function measure() {
			var h = el.getBoundingClientRect().height;
			if (h) root.style.setProperty('--nc-header-h', Math.round(h) + 'px');
		}
		var lastY = 0;
		function onScroll() {
			var y = window.scrollY;
			el.classList.toggle('is-stuck', y > 8);
			lastY = y;
		}
		measure();
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', measure, { passive: true });
		if ('ResizeObserver' in window) new ResizeObserver(measure).observe(el);
	}

	document.addEventListener('click', function (e) {
		if (e.target.closest('[data-nc-nav-open]')) { e.preventDefault(); NC.overlay.open($('[data-nc-nav]')); }
		if (e.target.closest('[data-nc-search-open]')) {
			e.preventDefault();
			NC.overlay.open($('[data-nc-search]'), 'input[name="q"]');
		}
	});

	/* ------------------------------------------------ predictive search */
	function search() {
		var panel = $('[data-nc-search]');
		if (!panel || !once(panel, 'search')) return;
		var input = $('input[name="q"]', panel);
		var results = $('[data-nc-search-results]', panel);
		var timer, ctrl;
		if (!input || !results) return;
		input.addEventListener('input', function () {
			clearTimeout(timer);
			var q = input.value.trim();
			if (q.length < 2) { results.innerHTML = ''; panel.classList.remove('has-results'); return; }
			timer = setTimeout(function () {
				if (ctrl) ctrl.abort();
				ctrl = 'AbortController' in window ? new AbortController() : null;
				fetch(
					(NC.routes.predictiveSearch || '/search/suggest') +
						'?q=' + encodeURIComponent(q) +
						'&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=nc-predictive-search',
					ctrl ? { signal: ctrl.signal } : {}
				)
					.then(function (r) { return r.text(); })
					.then(function (html) {
						var doc = new DOMParser().parseFromString(html, 'text/html');
						var inner = $('[data-nc-predictive]', doc);
						results.innerHTML = inner ? inner.innerHTML : '';
						panel.classList.toggle('has-results', !!inner);
					})
					.catch(function () {});
			}, 200);
		});
	}

	/* ---------------------------------------------------- mega menu
	   Hover on desktop is CSS; this adds click/keyboard support. */
	function megaMenu() {
		$$('[data-nc-mega-trigger]').forEach(function (btn) {
			if (!once(btn, 'mega')) return;
			var item = btn.closest('.nc-nav__item');
			btn.addEventListener('click', function (e) {
				if (window.matchMedia('(hover: hover)').matches && btn.tagName === 'A') return;
				e.preventDefault();
				var open = !item.classList.contains('is-open');
				$$('.nc-nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
				item.classList.toggle('is-open', open);
				btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			});
			item.addEventListener('keydown', function (e) {
				if (e.key === 'Escape') { item.classList.remove('is-open'); btn.focus(); }
			});
		});
		document.addEventListener('click', function (e) {
			if (!e.target.closest('.nc-nav__item')) $$('.nc-nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
		});
	}

	/* ------------------------------------------------------- copy code */
	document.addEventListener('click', function (e) {
		var c = e.target.closest('[data-nc-copy]');
		if (!c || !navigator.clipboard) return;
		navigator.clipboard.writeText(c.getAttribute('data-nc-copy')).then(function () {
			NC.toast({ title: 'Copied.', text: c.getAttribute('data-nc-copy'), cta: false });
		});
	});

	/* ------------------------------------------------------------- init */
	function initAll(ctx) {
		reveal(ctx);
		sliders(ctx);
		tabs(ctx);
		accordions(ctx);
		parallax(ctx);
		gallery(ctx);
		variants(ctx);
		pincode(ctx);
		bundles(ctx);
		filters(ctx);
	}
	NC.init = initAll;

	function boot() {
		header();
		megaMenu();
		search();
		initAll(document);
		stickyAtc();
		NC.cart.get().catch(function () {});
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
	else boot();

	document.addEventListener('shopify:section:load', function (e) {
		initAll(e.target);
		header();
		megaMenu();
		search();
		stickyAtc();
	});
})();
